export default __webpack_public_path__ + "static/media/award.c32735f4.svg";